import { Crown } from "lucide-react";
import { PlanChooser, TierTable } from "@/components/PremiumPlans";
import { useAuth } from "@/context/AuthContext";

export default function Premium() {
  const { user } = useAuth();
  const isPremium = user?.tier === "premium";

  return (
    <div className="max-w-2xl mx-auto px-6 sm:px-8 pt-12 sm:pt-16 pb-24" data-testid="premium-page">
      <div className="flex items-center gap-3 mb-2">
        <Crown className="w-6 h-6 text-[#9B7E4E]" strokeWidth={1.5} />
        <p className="font-body text-sm uppercase tracking-[0.2em] text-[#7A756E]">It Is Established Premium</p>
      </div>
      <h1 className="font-heading text-3xl sm:text-4xl text-[#2C2A29] tracking-tight">Establish without limits</h1>
      <p className="font-decree text-lg text-[#7A756E] mt-3">
        Unlimited decrees, full-length plans, every teaching, unlimited word studies — the whole armory, always open.
      </p>

      {isPremium ? (
        <div className="mt-10 border border-[#9B7E4E] bg-[#F3F0EA] rounded-sm p-6 text-center" data-testid="premium-active-banner">
          <Crown className="w-7 h-7 text-[#9B7E4E] mx-auto" strokeWidth={1.5} />
          <p className="font-heading text-xl text-[#2C2A29] mt-3">You have Premium access</p>
          <p className="font-body text-sm text-[#7A756E] mt-1">Manage your subscription anytime from your profile.</p>
        </div>
      ) : (
        <div className="mt-10 border border-[#D9D4CC] bg-[#FDFBF7] rounded-sm p-6 sm:p-8">
          <PlanChooser testIdPrefix="premium" />
        </div>
      )}

      <div className="mt-12">
        <p className="font-body text-xs uppercase tracking-[0.15em] text-[#7A756E] mb-3">Compare tiers</p>
        <TierTable testIdPrefix="premium" />
      </div>
    </div>
  );
}
